import React from "react";
import { Route, Navigate } from "react-router-dom";
const routes = all_routes;
import { all_routes } from "./all_routes";
//region icons
import FontawesomeIcons from "../feature-module/uiinterface/icons/fontawesome";
import FeatherIcons from "../feature-module/uiinterface/icons/feathericon";
import IonicIcons from "../feature-module/uiinterface/icons/ionicicons";
import MaterialIcons from "../feature-module/uiinterface/icons/materialicon";
import PE7Icons from "../feature-module/uiinterface/icons/pe7icons";
import SimplelineIcons from "../feature-module/uiinterface/icons/simplelineicon";
import ThemifyIcons from "../feature-module/uiinterface/icons/themify";
import WeatherIcons from "../feature-module/uiinterface/icons/weathericons";
import TypiconIcons from "../feature-module/uiinterface/icons/typicons";
import FlagIcons from "../feature-module/uiinterface/icons/flagicons";
import BootstrapIcons from "../feature-module/uiinterface/icons/bootstrapicons";
import RemixIcons from "../feature-module/uiinterface/icons/remixIcons";
import TablerIcon from "../feature-module/uiinterface/icons/tablericon";
import LayoutDemo from "../feature-module/layout-pages/layoutdemo";

//region auth
import Signin from "../feature-module/pages/login/signin";
import Forgotpassword from "../feature-module/pages/forgotpassword/forgotpassword";

//region Pereco

//region rollcall
import RollcallDashboard from "./../feature-module/Pereco/RollCall/Dashboard/Dashboard";
import RegistrationsList from "../feature-module/Pereco/RollCall/Registartions/Registrations";
import RejoinEmployeeList from "../feature-module/Pereco/RollCall/RejoinEmployees/RejoinEmployees";
import RollcallEmployeesList from "../feature-module/Pereco/RollCall/Employees/Employees";
import RollcallAdditionalDetails from "../feature-module/Pereco/RollCall/AdditionalDetails/AdditionalDetails";
import RollcallManualAttendanceList from "../feature-module/Pereco/RollCall/ManualAttendance/ManualAttendance";
import RollcallHolidaysList from "../feature-module/Pereco/RollCall/Configurations/Holidays/Holidays";
import RollcallDepartmentList from "../feature-module/Pereco/RollCall/Configurations/Department/Departments";
import RollcallEmployeeAccess from "../feature-module/Pereco/RollCall/Configurations/EmployeeAccess/EmployeeAccess";
import RollcallAssignShifts from "../feature-module/Pereco/RollCall/AssignShifts/AssignShifts";
import RollCallLeaves from "../feature-module/Pereco/RollCall/Leaves/Leaves";
import RollcallReports from "../feature-module/Pereco/RollCall/Reports/RollcallReports";
import LeaveAccurals from "../feature-module/Pereco/RollCall/Leaves/LeaveAccurals";
import LeaveSummary from "../feature-module/Pereco/RollCall/Leaves/LeaveSummary";
import RollcallLeaveTypes from "../feature-module/Pereco/RollCall/Configurations/LeaveTypes/LeaveTypes";
import RollcallNotification from "../feature-module/Pereco/RollCall/Dashboard/notification";
import ProtectedRoute from "../feature-module/Pereco/RollCall/Dashboard/protectedroute";
import Permissions from "../feature-module/Pereco/RollCall/Permissions/Permissions";
import EmployeeProfile from "../feature-module/Pereco/RollCall/Profile/Profile";
import RollcallSettings from "../feature-module/Pereco/RollCall/Settings/RollcallSettings";
import TeamMembers from "../feature-module/Pereco/RollCall/Team/TeamMembers";
import VisitorList from "../feature-module/Pereco/Visitor/VisitorList";
import VisitorReport from "../feature-module/Pereco/Visitor/VisitorReport";
import KpiMetrics from "../feature-module/Pereco/KPI/KpiMetrics";
import KpiMetricsReports from "../feature-module/Pereco/KPI/KpiMetricsReports";
import WageRegistrationsList from "../feature-module/Pereco/RollCall/WageRegistrations/WageRegistrations";
import KpiDashboard from "../feature-module/Pereco/KPI/KpiDashboard";
import KpiResponses from "../feature-module/Pereco/KPI/KpiResponses";
import ResponseSummary from "../feature-module/Pereco/KPI/Reports/ResponseSummary";
import KpiMetricDetails from "../feature-module/Pereco/KPI/Masters/KpiMetricDetails/KpiMetricDetails";
import RollcallGroupReports from "../feature-module/Pereco/RollCall/Reports/RollCallGroupReport";
import OrgDashboard from "../feature-module/Pereco/RollCall/Dashboard/OrgDashboard";
import RollcallShifts from "../feature-module/Pereco/RollCall/Configurations/Shifts/Shifts";
import EmployeesByShift from "../feature-module/Pereco/RollCall/AssignShifts/EmployeeShifts";
import EmployeeShiftHistory from "../feature-module/Pereco/RollCall/AssignShifts/EmployeeShiftHistory";
import SwipeLocationNames from "../feature-module/Pereco/RollCall/SwipeLocation/SwipeLocation";
import EventVisitors from "../feature-module/Pereco/Visitor/EventVisitors/EventVisitors";
import Events from "../feature-module/Pereco/Visitor/Events/Events";
import RollcallKpiReports from "../feature-module/Pereco/RollCall/Reports/RollcallKpiReports";
import KpiPerformanceReport from "../feature-module/Pereco/KPI/Reports/PerformanceReport";
import BranchScoreMatrix from "../feature-module/Pereco/KPI/Reports/AllBranchReport";

export const publicRoutes = [
  {
    id: 49,
    path: routes.fontawesome,
    name: "fontawesome",
    element: <FontawesomeIcons />,
    route: Route,
  },
  {
    id: 50,
    path: routes.feathericon,
    name: "feathericon",
    element: <FeatherIcons />,
    route: Route,
  },
  {
    id: 51,
    path: routes.ionicicons,
    name: "ionicicons",
    element: <IonicIcons />,
    route: Route,
  },
  {
    id: 52,
    path: routes.materialicons,
    name: "materialicons",
    element: <MaterialIcons />,
    route: Route,
  },
  {
    id: 53,
    path: routes.pe7icons,
    name: "pe7icons",
    element: <PE7Icons />,
    route: Route,
  },
  {
    id: 54,
    path: routes.simpleline,
    name: "simpleline",
    element: <SimplelineIcons />,
    route: Route,
  },
  {
    id: 55,
    path: routes.themifyicons,
    name: "themifyicon",
    element: <ThemifyIcons />,
    route: Route,
  },
  {
    id: 56,
    path: routes.iconweather,
    name: "iconweather",
    element: <WeatherIcons />,
    route: Route,
  },
  {
    id: 57,
    path: routes.typicons,
    name: "typicons",
    element: <TypiconIcons />,
    route: Route,
  },
  {
    id: 58,
    path: routes.flagicons,
    name: "flagicons",
    element: <FlagIcons />,
    route: Route,
  },

  {
    id: 106,
    path: routes.remixIcon,
    name: "remixIcon",
    element: <RemixIcons />,
    route: Route,
  },
  {
    id: 107,
    path: routes.BootstrapIcon,
    name: "BootstrapIcon",
    element: <BootstrapIcons />,
    route: Route,
  },
  {
    id: 108,
    path: routes.TablerIcon,
    name: "TablerIcon",
    element: <TablerIcon />,
    route: Route,
  },

  {
    id: 116,
    path: "*",
    name: "NotFound",
    element: <Navigate to="/" />,
    route: Route,
  },
  {
    id: 117,
    path: "/",
    name: "Root",
    element: <Navigate to="/signin" />,
    route: Route,
  },

  {
    id: 162,
    path: routes.Horizontal,
    name: "layout-horizontal",
    element: <LayoutDemo />,
    route: Route,
  },
  {
    id: 163,
    path: routes.Detached,
    name: "layout-detached",
    element: <LayoutDemo />,
    route: Route,
  },
  {
    id: 164,
    path: routes.Modern,
    name: "layout-modern",
    element: <LayoutDemo />,
    route: Route,
  },
  {
    id: 165,
    path: routes.TwoColumn,
    name: "layout-two-column",
    element: <LayoutDemo />,
    route: Route,
  },
  {
    id: 166,
    path: routes.Hovered,
    name: "layout-hovered",
    element: <LayoutDemo />,
    route: Route,
  },
  {
    id: 167,
    path: routes.Boxed,
    name: "layout-boxed",
    element: <LayoutDemo />,
    route: Route,
  },
  {
    id: 168,
    path: routes.RTL,
    name: "layout-rtl",
    element: <LayoutDemo />,
    route: Route,
  },
  {
    id: 169,
    path: routes.Dark,
    name: "layout-dark",
    element: <LayoutDemo />,
    route: Route,
  },

  {
    id: 202,
    path: routes.rollcalldashboard,
    name: "rollcalldashboard",
    element: (
      <ProtectedRoute>
        <RollcallDashboard />
      </ProtectedRoute>
    ),
    route: Route,
  },

  {
    id: 203,
    path: routes.rollcallregistrations,
    name: "rollcallregistrations",
    element: <RegistrationsList />,
    route: Route,
  },
  {
    id: 204,
    path: routes.rollcallrejoinemployees,
    name: "rollcallrejoinemployees",
    element: <RejoinEmployeeList />,
    route: Route,
  },
  {
    id: 205,
    path: routes.rollcallemployeeslist,
    name: "rollcallemployeeslist",
    element: <RollcallEmployeesList />,
    route: Route,
  },
  {
    id: 206,
    path: routes.rollcalladditionaldetails,
    name: "rollcalladditionaldetails",
    element: <RollcallAdditionalDetails />,
    route: Route,
  },
  {
    id: 207,
    path: routes.rollcallmanualattendance,
    name: "rollcallmanualattendance",
    element: <RollcallManualAttendanceList />,
    route: Route,
  },
  {
    id: 208,
    path: routes.rollcallholidaysList,
    name: "rollcallholidaysList",
    element: <RollcallHolidaysList />,
    route: Route,
  },
  {
    id: 209,
    path: routes.rollcalldepartmentsList,
    name: "rollcalldepartmentsList",
    element: <RollcallDepartmentList />,
    route: Route,
  },
  {
    id: 210,
    path: routes.rollcallemployeesaccessList,
    name: "rollcallemployeesaccessList",
    element: <RollcallEmployeeAccess />,
    route: Route,
  },
  {
    id: 211,
    path: routes.rollcallassignshifts,
    name: "rollcallassignshifts",
    element: <RollcallAssignShifts />,
    route: Route,
  },
  {
    id: 212,
    path: routes.rollcallreports,
    name: "rollcallreports",
    element: <RollcallReports />,
  },

  {
    id: 213,
    path: routes.rollcallleaveslist,
    name: "rollcallleaveslist",
    element: <RollCallLeaves />,
    route: Route,
  },

  {
    id: 214,
    path: routes.rollcallleaveaccurals,
    name: "rollcallleaveaccurals",
    element: <LeaveAccurals />,
    route: Route,
  },
  {
    id: 215,
    path: routes.rollcallleavesummary,
    name: "rollcallleavesummary",
    element: <LeaveSummary />,
    route: Route,
  },
  {
    id: 216,
    path: routes.rollcallleavetypes,
    name: "rollcallleavetypes",
    element: <RollcallLeaveTypes />,
    route: Route,
  },
  {
    id: 217,
    path: routes.rollcallnotification,
    name: "rollcallnotification",
    element: <RollcallNotification />,
    route: Route,
  },
  {
    id: 218,
    path: routes.rollcallpermissions,
    name: "rollcallpermissions",
    element: <Permissions />,
    route: Route,
  },
  {
    id: 220,
    path: routes.rollcallsettings,
    name: "rollcallsettings",
    element: <RollcallSettings />,
    route: Route,
  },
  {
    id: 233,
    path: routes.rollcallteammembers,
    name: "rollcallteammembers",
    element: <TeamMembers />,
  },
  //visitor routes
  {
    id: 234,
    path: routes.rollcallvisitorlist,
    name: "rollcallvisitorlist",
    element: <VisitorList />,
    route: Route,
  },
  {
    id: 235,
    path: routes.rollcallvisitorreport,
    name: "rollcallvisitorreport",
    element: <VisitorReport />,
    route: Route,
  },

  {
    id: 236,
    path: routes.rollcallkpimetrics,
    name: "rollcallkpimetrics",
    element: <KpiMetrics />,
    route: Route,
  },
  {
    id: 237,
    path: routes.rollcallkpimetricsreport,
    name: "rollcallkpimetricsreport",
    element: <KpiMetricsReports />,
    route: Route,
  },
  {
    id: 238,
    path: routes.rollcallwageregistrations,
    name: "rollcallwageregistrations",
    element: <WageRegistrationsList />,
    route: Route,
  },
  {
    id: 239,
    path: routes.rollcallkpidashboard,
    name: "rollcallkpidashboard",
    element: <KpiDashboard />,
    route: Route,
  },
  {
    id: 240,
    path: routes.rollcallkpiresponses,
    name: "rollcallkpiresponses",
    element: <KpiResponses />,
    route: Route,
  },
  {
    id: 241,
    path: routes.rollcallresponseSummary,
    name: "rollcallresponseSummary",
    element: <ResponseSummary />,
    route: Route,
  },
  {
    id: 242,
    path: routes.rollcallmetricdetails,
    name: "rollcallmetricdetails",
    element: <KpiMetricDetails />,
    route: Route,
  },
  {
    id: 243,
    path: routes.rollcallgroupreports,
    name: "rollcallgroupreports",
    element: <RollcallGroupReports />,
    route: Route,
  },
  {
    id: 244,
    path: routes.rollcallshifts,
    name: "rollcallshifts",
    element: <RollcallShifts />,
    route: Route,
  },
  {
    id: 245,
    path: routes.rollcallEmpShifts,
    name: "rollcallEmpShifts",
    element: <EmployeesByShift />,
    route: Route,
  },
  {
    id: 246,
    path: routes.rollcallEmpShiftInfo,
    name: "rollcallEmpShiftInfo",
    element: <EmployeeShiftHistory />,
    route: Route,
  },
  {
    id: 247,
    path: routes.rollcallSwipeLocation,
    name: "rollcallSwipeLocation",
    element: <SwipeLocationNames />,
    route: Route,
  },
  {
    id: 248,
    path: routes.rollcallOrgDashboard,
    name: "rollcallOrgDashboard",
    element: <OrgDashboard />,
    route: Route,
  },
  {
    id: 249,
    path: routes.rollcallEvents,
    name: "rollcallEvents",
    element: <Events />,
    route: Route,
  },
  {
    id: 250,
    path: routes.rollcallEventVisitors,
    name: "rollcallEventVisitors",
    element: <EventVisitors />,
    route: Route,
  },
  {
    id: 251,
    path: routes.rollcallkpireports,
    name: "rollcallkpireports",
    element: <RollcallKpiReports />,
    route: Route,
  },
  {
    id: 254,
    path: routes.rollcallkpiPerformanceReport,
    name: "rollcallkpiPerformanceReport",
    element: <KpiPerformanceReport />,
    route: Route,
  },
  {
    id: 255,
    path: routes.rollcallKpiBranchScore,
    name: "rollcallKpiBranchScore",
    element: <BranchScoreMatrix />,
    route: Route,
  },
];

export const posRoutes = [];

export const pagesRoute = [
  {
    id: 1,
    path: routes.signin,
    name: "signin",
    element: <Signin />,
    route: Route,
  },
  {
    id: 7,
    path: routes.forgotPassword,
    name: "forgotPassword",
    element: <Forgotpassword />,
    route: Route,
  },
  {
    id: 8,
    path: routes.profile,
    name: "profile",
    element: <EmployeeProfile />,
    route: Route,
  },
];
